import React from 'react'
import './ExternalFonts.css';
// import Banner from '../../public/SignBoard.png';

export const Header = () => {
  return (
    <header className='flex justify-center'>
        <img src="/images/SignBoard.png" alt="Banner"/>
    </header>
  )
}
//<p>Insurance, Please!</p>
